'use client'

import { useContext } from 'react'
import { AuthContext } from '@/lib/commerce/providers/AuthProvider'
import type { AuthContextValue } from '@/lib/commerce/types/auth'

export function useAuth(): AuthContextValue {
  const ctx = useContext(AuthContext)
  if (!ctx) throw new Error('useAuth must be used within <AuthProvider>')
  return ctx
}
